import React from "react";
import { Controller } from "react-hook-form";

import TextField from "@mui/material/TextField";

const ControlledFileInput = ({
	control,
	defaultValue,
	name,
	label,
	error,
	errorMessage,
	shrinkLabel = true,
	startAdornment,
	endAdornment,
	variant = "outlined",
	...rest
}) => {
	return (
        <Controller
			control={control}
			name={name}
			defaultValue={defaultValue && defaultValue}
			render={({ field: { onChange, value } }) => (
				<TextField
                    size="small"
                    value={value?.fileName}
                    label={label}
                    variant={variant}
                    fullWidth
                    onChange={(event) => {
						onChange(event.target.files[0]);
					}}
                    error={error}
                    helperText={errorMessage ? errorMessage : ""}
                    {...rest}
                    slotProps={{
                        input: {
                            startAdornment: startAdornment,
                            endAdornment: endAdornment,
                        },

                        inputLabel: shrinkLabel && { shrink: shrinkLabel }
                    }} />
			)}
		></Controller>
    );
};

export default ControlledFileInput;
